import { numberFormatter } from '../../utils/number-formatter';

export const getTotal = (list: { key: string; value: number }[]) =>
  list.reduce((total, item) => total + item.value, 0);

export const getPercentage = (num: number, totalNum: number) => {
  const percentNum = (num * 100) / totalNum;
  return Math.round(percentNum);
};

export const formatInput = (raw: string) => {
  if (raw === '') return raw;
  if (raw.includes('.')) {
    const [intPart, decimalPart] = raw.split('.');
    return `${numberFormatter.format(Number(intPart))}.${decimalPart}`;
  }
  return numberFormatter.format(Number(raw));
};
